<!-- ========== Dock Sidebar Start ========== -->
<div class="dock-sidebar" (mouseleave)="hideFlyout()">
    <div class="dock-menu">
        <ng-container *ngFor="let entry of menuEntries">

            <!-- Divider -->
            <ng-container *ngIf="isDivider(entry)">
                <div class="dock-divider" aria-hidden="true"></div>
            </ng-container>

            
            <!-- Standalone item -->
            <ng-container *ngIf="!isGroup(entry) && !isDivider(entry)">
                <div class="dock-item" *ngIf="isVisible(entry)"
                     [class.dock-item-active]="isRouteActive(entry.route)"
                     (click)="entry.route === 'queues' ? onQueuesList(true) : onQueuesList(false); navigateTo(entry.route)"
                     [pTooltip]="entry.label" tooltipPosition="right" appendTo="body">
                    <i [class]="entry.icon"></i>
                    <span class="dock-label">{{ entry.label }}</span>
                    <span class="dock-badge" *ngIf="badgeCount(entry) as count">{{ count }}</span>
                </div>
            </ng-container>

            <!-- Group item — both mouseenter (desktop hover) and click
                 (touch) so the flyout opens on tablets/phones too. -->
            <ng-container *ngIf="isGroup(entry)">
                <div class="dock-item dock-item-group" *ngIf="isGroupVisible(entry)"
                     [class.dock-item-active]="isGroupActive(entry)"
                     [class.dock-item-open]="activeGroup === entry"
                     (mouseenter)="showFlyout(entry, $event)"
                     (click)="toggleFlyout(entry, $event)">
                    <i [class]="entry.icon"></i>
                    <span class="dock-label">{{ entry.label }}</span>
                    <i class="dock-chevron mdi mdi-chevron-right"></i>
                    <span class="dock-group-dot"></span>
                </div>

                <!-- Inline children — only renders/visible on mobile (≤768px)
                     when this group is the active one. Hidden on desktop via
                     CSS so the existing flyout behavior is preserved there. -->
                <div class="dock-inline-children" *ngIf="isGroupVisible(entry) && activeGroup === entry">
                    <div *ngFor="let child of getVisibleChildren(entry)"
                         class="dock-inline-child"
                         [class.dock-inline-child-active]="isRouteActive(child.route)"
                         (click)="child.route === 'queues' ? onQueuesList(true) : onQueuesList(false); navigateTo(child.route); $event.stopPropagation()">
                        <i [class]="child.icon"></i>
                        <span>{{ child.label }}</span>
                        <span class="dock-badge" *ngIf="badgeCount(child) as count">{{ count }}</span>
                    </div>
                </div>
            </ng-container>

        </ng-container>
    </div>

    <!-- Flyout panel -->
    <div class="dock-flyout" *ngIf="activeGroup"
         [style.top.px]="flyoutTop"
         (mouseenter)="activeGroup = activeGroup"
         (mouseleave)="hideFlyout()">
        <div class="dock-flyout-header">{{ activeGroup.label }}</div>
        <div class="dock-flyout-items">
            <ng-container *ngFor="let child of getVisibleChildren(activeGroup)">
                <div class="dock-flyout-item"
                     [class.dock-flyout-item-active]="isRouteActive(child.route)"
                     (click)="child.route === 'queues' ? onQueuesList(true) : onQueuesList(false); navigateTo(child.route)">
                    <i [class]="child.icon"></i>
                    <span>{{ child.label }}</span>
                    <span class="dock-badge" *ngIf="badgeCount(child) as count">{{ count }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<!-- Dock Sidebar End -->
